import Description from "component/Common/Description";
import { getRating } from "helpers/hotelHelper";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import { useTranslation } from "react-i18next";
import { BsStarFill } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
const IMAGE_PLACEHOLDER =
    "https://t3.ftcdn.net/jpg/06/86/19/34/240_F_686193407_DHZwjeydBOR1tEDkLAzwM3w5kYstRzzB.jpg";

const DetailsArea = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { hotelSelection } = useHotelContext();
    const { selectedHotel } = hotelSelection || {};
    const rating = getRating(selectedHotel?.stars);

    return (
        <>
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2 ">
                    <div className="flex flex-row justify-between items-center">
                        <h2 className="text-2xl font-semibold truncate">
                            {selectedHotel?.name}
                        </h2>
                        <div className=" flex gap-1 items-center">
                            {[1, 2, 3, 4, 5].map((i) => (
                                <BsStarFill
                                    key={i}
                                    size={16}
                                    className={`${
                                        i <= rating
                                            ? "text-yellow-500"
                                            : "text-gray-300"
                                    }`}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <img
                            src={selectedHotel?.image || IMAGE_PLACEHOLDER}
                            alt={selectedHotel?.name}
                            className="w-full aspect-video object-cover rounded-md"
                        />
                        <div className="flex flex-row  gap-2">
                            <FaLocationDot
                                size={20}
                                className="text-gray-500"
                            />
                            <span className="text-md text-gray-500">
                                {selectedHotel?.address}
                            </span>
                        </div>
                        {hotelSelection?.supplementsArrays &&
                            hotelSelection?.supplementsArray.length > 0 && (
                                <div className="p-2 my-2 border-red-600 border-2 text-red-500 rounded-md bg-red-100 font-semibold">
                                    <div className="">
                                        {t("taxNotIncluded")}
                                    </div>
                                </div>
                            )}
                        <Description
                            rawDescription={selectedHotel?.description}
                            title={t("hotelDescription")}
                        />
                        {selectedHotel?.comments &&
                            selectedHotel?.comments.length > 0 && (
                                <Description
                                    rawDescription={hotelSelection?.comments}
                                    title={t("important")}
                                />
                            )}
                    </div>
                </div>
                <div className="justify-end mt-4 flex gap-2">
                    <button
                        onClick={() => {
                            navigate("/hotel-search");
                        }}
                        type="button"
                        className="w-[40%] btn border-main-color border-2 hover:text-main-color  bg-transparent text-main-color"
                    >
                        {t("back")}
                    </button>
                    <button
                        onClick={() => navigate("/hotel-booking")}
                        type="submit"
                        className="w-[60%] btn bg-main-color text-white"
                    >
                        {t("continue")}
                    </button>
                </div>
            </div>
        </>
    );
};

export default DetailsArea;
